export default "__VITE_ASSET__BsPu5ArG__"